import { create, string, type } from 'superstruct';

import { Collection } from '~modules/media-library/model/Collection';

export const CollectionValidator = type({
  id: string(),
  attributes: type({
    title: string(),
    short_description: string(),
    responsible_person: string(),
  }),
});

export function makeCollection(raw: unknown) {
  let collection: Collection;

  try {
    const rawCollection = create(raw, CollectionValidator);
    collection = {
      id: rawCollection.id,
      title: rawCollection.attributes.title,
      description: rawCollection.attributes.short_description,
      responsiblePerson: rawCollection.attributes.responsible_person,
    };
  } catch (err) {
    console.error(err);
  }
  return collection;
}
